import {
  LinkBuilderClient,
  type LinkBuilderDataEntryRes,
  type LinkBuilderPresetCriteria,
  type LinkBuilderPresetReq,
  type LinkBuilderPresetRes,
  type LinkBuilderPresetResultsList,
} from '@n3oltd/karakoram.tags.sdk.link-builder'
import { serviceBaseUrl } from '@/lib/api/baseUrl'
import { createConfig } from '@/lib/api/config'
import { createHttp } from '@/lib/api/http'

interface CallOptions {
  token: string
  subscriptionCode: string
  signal?: AbortSignal
}

function client({ token, subscriptionCode, signal }: CallOptions): LinkBuilderClient {
  return new LinkBuilderClient(
    createConfig(token, subscriptionCode),
    serviceBaseUrl('tags'),
    createHttp(signal),
  )
}

export function getDataEntry(opts: CallOptions): Promise<LinkBuilderDataEntryRes> {
  return client(opts).getDataEntry()
}

export function findPresets(
  opts: CallOptions,
  criteria: LinkBuilderPresetCriteria,
): Promise<LinkBuilderPresetResultsList> {
  return client(opts).findPresets(criteria)
}

export function getPresetById(opts: CallOptions, presetId: string): Promise<LinkBuilderPresetRes> {
  return client(opts).getPresetById(presetId)
}

export function createPreset(opts: CallOptions, body: LinkBuilderPresetReq): Promise<LinkBuilderPresetRes> {
  return client(opts).createPreset(body)
}

export function updatePreset(
  opts: CallOptions,
  presetRevisionId: string,
  body: LinkBuilderPresetReq,
): Promise<void> {
  return client(opts).updatePreset(presetRevisionId, body)
}

export function deletePreset(opts: CallOptions, presetRevisionId: string): Promise<void> {
  return client(opts).deletePreset(presetRevisionId)
}
